import { Menu as MenuPrimitive } from '@base-ui/react/menu';

export type DropdownMenuGroupProps = MenuPrimitive.Group.Props;

const DropdownMenuGroup = ({ ...props }: DropdownMenuGroupProps) => {
  return <MenuPrimitive.Group data-slot="dropdown-menu-group" {...props} />;
};

export default DropdownMenuGroup;
